import { dialogController } from '@sydle/ui-design-system';
import type { Components } from '../../../../components';
import { t } from '../../../one-translation-bundle/translation-bundles';

export type DialogOptionsArgs = {
  title: string;

  /**
   * Submit label. Defaul is "Confirm"
   */
  submitLabel?: string;

  /**
   * Cancel label. Defaul is "Cancel"
   */
  cancelLabel?: string;
  elementToAppend: HTMLElement;
  dialogPosition?: 'absolute' | 'fixed';
  props: Components.SyOneDialogOptions;
};

// TODO: lidar com remoção do sy-dialog do DOM
// TODO: lidar com concorrência de dialogs
export const dialogOptions = async ({
  title,
  submitLabel,
  cancelLabel,
  dialogPosition,
  elementToAppend,
  props,
}: DialogOptionsArgs): Promise<string> => {
  const dialog = dialogController.create<Components.SyOneDialogOptions>({
    elementToAppend,
    position: dialogPosition,
    header: {
      dialogTitle: title,
    },
    content: {
      slotComponent: 'sy-one-dialog-options',
      slotComponentPropsValues: props,
    },
    footer: {
      submitLabel: submitLabel || t('WORKSPACE_MESSAGES', 'CONFIRM'),
      cancelLabel: cancelLabel || t('WORKSPACE_MESSAGES', 'CANCEL'),
      buttonsPosition: 'end',
    },
  });

  dialog.open();

  const dialogAction = await dialog.onClose();

  if (dialogAction !== 'submit') return null;

  const dialogOptionsElement = dialog.element.querySelector('sy-one-dialog-options');
  const selectedOption = dialogOptionsElement.selected;
  return selectedOption;
};
